__turbopack_context__.v({
  "award": "style-module-scss-module__M5foka__award",
  "icon": "style-module-scss-module__M5foka__icon",
});
